import { getProductCategory } from './allProducts'

const _resolveAssetPath = (loader, productId, ext) => {
  if (!loader) return null
  try {
    const p = `./${productId}${ext}`
    if (loader.keys().includes(p)) return loader(p)
  } catch (_) {}
  return null
}

const categoryAssets = {}

export const getAssetsForCategory = (category) => categoryAssets[category] || null

export const getProductImages = (product) => {
  if (!product) return []
  const category = getProductCategory(product.id)
  const assets = getAssetsForCategory(category)
  const ext = product.imageExt || '.webp'
  const list = []

  if (product.image) {
    list.push({ src: product.image, alt: product.name, label: 'Front' })
  }

  if (assets) {
    const contentSrc = _resolveAssetPath(assets.content, product.id, ext)
    if (contentSrc) {
      list.push({ src: contentSrc, alt: `${product.name} content`, label: 'Content' })
    }
    const backSrc = _resolveAssetPath(assets.back, product.id, ext)
    if (backSrc) {
      list.push({ src: backSrc, alt: `${product.name} back`, label: 'Back' })
    }
  }

  return list
}

const _tryFetchDescription = (url) =>
  fetch(url).then((r) => r.text()).catch(() => '')

export const loadProductDescription = (product) => {
  if (!product) return Promise.resolve('')
  if (product.longDescription) return Promise.resolve(product.longDescription)
  if (product.description) return Promise.resolve(product.description)

  const category = getProductCategory(product.id)
  const assets = getAssetsForCategory(category)
  if (!assets) return Promise.resolve('')

  try {
    const p = `./${product.id}/description.txt`
    if (assets.description.keys().includes(p)) {
      return _tryFetchDescription(assets.description(p))
    }
  } catch (_) {}

  return Promise.resolve('')
}
